// extracted by mini-css-extract-plugin
export default {"ellipseAnimation":"XnKw5","ellipse-animation":"kYxuw","ellipse":"FA7nX","skeleton-progress":"_7Ekgv"};